import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Card, InputItem } from 'antd-mobile';
import { GetAgentUser } from '../../../api/order';
import AgentUserList from '../components/AgentUserList';
import { UrlSearch } from '../../../utils/utils';
import Permission from '../components/Permission';
import { AclKeys } from '../utils/permissions';

const initParams = {
    Limit: 1000,
    Offset: 0
}

function UserList(){

    const [searchValue, setSearchValue] = useState('')

    const AgentName = useMemo(() => {
        return UrlSearch("AgentName")
    }, [])

    const AgentId = useMemo(() => {
        return UrlSearch("AgentId")
    }, [])

    const [agentUser, setAgentUser] = useState([])
    const [loading, setLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const handleSearch = useCallback((value) => {
        setSearchValue(value)
    }, [])

    const filterAgentList = useMemo(() => {
        return agentUser.filter(item => {
            if(searchValue){
                return String(item.Id).indexOf(searchValue) > -1 || (item.Email).toLowerCase().indexOf(searchValue.toLowerCase()) > -1
            }else{
                return true
            }
        })
    }, [agentUser, searchValue])

    useEffect(() => {
        if(AgentId){
            getAgentUser({
                ...initParams,
                AgentId
            })
        }
    }, [AgentId])

    // 获取关联的用户
    const getAgentUser = (data) => {
        setLoading(true)
        GetAgentUser(data).then(res => {
            const { Data } = res;
            setAgentUser(Data || [])
            setLoading(false)
        }).catch((err) => {
            setErrorMessage(err.message)
            setLoading(false)
        })
    }

    return <>
        <Permission aclKey={AclKeys.AllUserManage}>
            <InputItem
                value={searchValue}
                onChange={handleSearch}
                clear
                placeholder="用户名搜索"
            ></InputItem>
            <Card>
                <Card.Header
                    title={`(${AgentName})关联用户列表`}
                />
                <Card.Body>
                    <AgentUserList
                        loading={loading}
                        errorMessage={errorMessage}
                        companyList={filterAgentList}
                    />
                </Card.Body>
            </Card>
        </Permission>
    </>
}

export default UserList;